
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/newhomes/[precon-type]",
      function () {
        return require("private-next-pages/newhomes/[precon-type]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/newhomes/[precon-type]"])
      });
    }
  